// styles
import { chartDashboardType02Style } from 'styles';

// libraries
import styled from 'styled-components';

export const StyledNoticeCard = styled.div`
  > div {
    > div {
      ${chartDashboardType02Style}

      .pjt-lists {
        gap: 6px;
        margin-top: 10px;
        overflow-y: auto;
      }
    }
  }
`;
